import React from 'react';
import { ExportButton } from '@common/components';
import { gql, useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import Filters from 'works/legacy/lib/filters';

const GENERATE_CSV_EXPORT = gql`
  mutation createStaffingRequestsExport(
    $input: CreateStaffingRequestsExportInput!
  ) {
    createStaffingRequestsExport(input: $input) {
      exportFile {
        id
        filename
        downloadUrl
      }
    }
  }
`;

const ALL_STAFFING_REQUEST_TYPES = ['on_demand', 'long_term'];

type GenerateCsvExportResponseType = {
  createStaffingRequestsExport: {
    exportFile: {
      id: string;
      filename: string;
      downloadUrl: string;
    };
  };
};

type GenerateCsvExportVariablesType = {
  input: {
    filters: object;
    staffingRequestTypes: string[];
  };
};

export function StaffingRequestsExportButton() {
  const LOCALSTORAGE_FILTER_KEY = 'StaffingRequestListTable';

  const [performExport, { loading }] = useMutation<
    GenerateCsvExportResponseType,
    GenerateCsvExportVariablesType
  >(GENERATE_CSV_EXPORT, {
    onCompleted: ({ createStaffingRequestsExport: { exportFile } }) => {
      window.location.href = exportFile.downloadUrl;
      createMessage('success', 'CSV Export generated successfully.');
    },
    onError: () => {
      createMessage('error', 'CSV Export failed. Please try again.');
    },
  });

  const onClick = () => {
    performExport({
      variables: {
        input: {
          filters: Filters.getFilters(LOCALSTORAGE_FILTER_KEY),
          staffingRequestTypes: ALL_STAFFING_REQUEST_TYPES,
        },
      },
    });
  };

  return (
    <ExportButton onClick={onClick} loading={loading}>
      Export
    </ExportButton>
  );
}
